import Layout from '@layout/Index'

export const userTag = [
  {
    path: '/usertag',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "user-credit-form" */ './pages/UserTagTable.vue'),
        name: '用户标签列表',
        meta: {
          title: '用户标签列表',
        },
      },
      {
        path: 'create',
        component: () => import(/* webpackChunkName: "user-credit-form" */ './pages/UserTagForm.vue'),
        name: '用户标签创建',
        meta: {
          title: '用户标签创建',
        },
      },
      {
        path: 'update/:id',
        component: () => import(/* webpackChunkName: "user-credit-form" */ './pages/UserTagForm.vue'),
        name: '用户标签编辑',
        meta: {
          title: '用户标签编辑',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/user-tag/userTag.route.js